import React from 'react';
import { BuildingLibraryIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';
import SettingsModuleRedirect from './SettingsModuleRedirect';

const ClassroomSettings = () => {
  const { t } = useLanguage();

  return (
    <SettingsModuleRedirect
      icon={BuildingLibraryIcon}
      title={t('settingsPage.classroomsRedirectTitle')}
      description={t('settingsPage.classroomsRedirectDesc')}
      linkTo="/classrooms"
      linkLabel={t('settingsPage.classroomsRedirectLink')}
      noticeTitle={t('settingsPage.moduleRedirectNoticeTitle')}
      noticeBody={t('settingsPage.classroomsRedirectNotice')}
      bullets={[
        t('settingsPage.classroomsBullet1'),
        t('settingsPage.classroomsBullet2'),
        t('settingsPage.classroomsBullet3'),
      ]}
    />
  );
};

export default ClassroomSettings;
